import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiFormSelect, mdiWindowRestore, mdiEmailNewsletter } from '@mdi/js';
import AppHeader from '../components/AppHeader';
import '../pages/Common.css';
import '../pages/Dashboard.css';
import '../pages/header.css';
import './DevPagesIndex.css';

/**
 * DevPagesIndex - Developer landing page linking to all demo/showcase pages.
 * Portal type: Portal Landing (.portal-header-card)
 * Route is gated by DevProtectedRoute (developer accounts only).
 */
const DevPagesIndex = () => {
    const navigate = useNavigate();

    const devCards = [
        { path: '/form-input-showcase', icon: mdiFormSelect, title: 'Form Input Showcase', description: 'All CustomFormInput variations: checkboxes, radios, pills, colour variants, error and disabled states' },
        { path: '/test-modals', icon: mdiWindowRestore, title: 'Test Modals', description: 'BaseModal and ConfirmationModal patterns for visual verification' },
        { path: '/email-copy-showcase', icon: mdiEmailNewsletter, title: 'Email Copy Showcase', description: 'Rendered previews of platform email templates and copy' },
    ];

    return (
        <div className="dashboard-container org-console">
            <AppHeader activeItem="home" />

            <div className="dashboard-main">
                <div className="dashboard-content-wrapper dev-pages-index" style={{ maxWidth: '900px' }}>
                    {/* Portal Header Card */}
                    <div className="portal-header-card">
                        <div className="portal-header-title-row">
                            <button
                                onClick={() => navigate('/dashboard')}
                                className="back-nav-btn">
                                ← Dashboard
                            </button>
                            <h1 className="portal-header-title">Developer Pages</h1>
                        </div>
                        <p className="portal-header-subtitle">
                            Internal demo and showcase pages. Visible to developer accounts only.
                        </p>
                    </div>

                    {/* Navigation Cards Grid */}
                    <div className="dev-pages-grid">
                        {devCards.map((card) => (
                            <Link
                                key={card.path}
                                to={card.path}
                                className="content-card nav-card dev-pages-nav-card">
                                <div className="dev-pages-card-header">
                                    <Icon path={card.icon} size={1.4} color="var(--dl-color-purple-default)" />
                                    <h3 className="dev-pages-card-title">{card.title}</h3>
                                </div>
                                <p className="dev-pages-card-description">{card.description}</p>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DevPagesIndex;
